// Demo data for listings when API is unavailable
const DEMO_LISTINGS = [
  {
    ListingKey: "DEMO001",
    CrossStreet: "Bay Street & Bloor Street",
    CityRegion: "Downtown Core",
    StreetNumber: "150",
    StreetName: "Bay",
    StreetSuffix: "St",
    City: "Toronto",
    StateOrProvince: "ON",
    PostalCode: "M5J 2N3",
    ListPrice: 1250000,
    OriginalEntryTimestamp: new Date("2024-01-15").toISOString(),
    BedroomsTotal: 3,
    BathroomsTotalInteger: 2,
    LivingAreaRange: 1800,
    BuildingAreaTotal: 1800,
    PublicRemarks: "Beautiful modern condominium in the heart of downtown Toronto. Features spacious living areas, updated kitchen, and stunning city views.",
    PublicRemarksExtras: "Additional features include in-suite laundry, storage locker, and one parking space. Building amenities include 24-hour concierge, fitness center, and rooftop terrace.",
    PropertyType: "Residential",
    PropertySubType: "Condo Apartment",
    HeatSource: "Gas",
    HeatType: "Forced Air",
    GarageType: "Underground",
    ParkingTotal: 1,
    DirectionFaces: "South",
    LotSizeRangeAcres: "0.05",
    LotSizeUnits: "Acres",
    Basement: ["None"],
    ListOfficeName: "Premium Realty Group",
    ListAOR: "Toronto Real Estate Board",
    StandardStatus: "Active",
    ListAgentKey: "12345",
  },
  {
    ListingKey: "DEMO002",
    CrossStreet: "Yonge Street & Eglinton Avenue",
    CityRegion: "Midtown",
    StreetNumber: "245",
    StreetName: "Yonge",
    StreetSuffix: "St",
    City: "Toronto",
    StateOrProvince: "ON",
    PostalCode: "M4P 1E1",
    ListPrice: 895000,
    OriginalEntryTimestamp: new Date("2024-01-10").toISOString(),
    BedroomsTotal: 2,
    BathroomsTotalInteger: 2,
    LivingAreaRange: 1200,
    BuildingAreaTotal: 1200,
    PublicRemarks: "Charming two-bedroom apartment with hardwood floors, modern finishes, and convenient access to public transit.",
    PublicRemarksExtras: "Additional property details and features. Perfect for young professionals or couples.",
    PropertyType: "Residential",
    PropertySubType: "Condo Apartment",
    HeatSource: "Gas",
    HeatType: "Forced Air",
    GarageType: "Underground",
    ParkingTotal: 1,
    DirectionFaces: "West",
    LotSizeRangeAcres: "0.05",
    LotSizeUnits: "Acres",
    Basement: ["None"],
    ListOfficeName: "Premium Realty Group",
    ListAOR: "Toronto Real Estate Board",
    StandardStatus: "Active",
    ListAgentKey: "12345",
  },
  {
    ListingKey: "DEMO003",
    CrossStreet: "King Street West & Spadina Avenue",
    CityRegion: "Entertainment District",
    StreetNumber: "88",
    StreetName: "King",
    StreetSuffix: "St W",
    City: "Toronto",
    StateOrProvince: "ON",
    PostalCode: "M5V 1M4",
    ListPrice: 1850000,
    OriginalEntryTimestamp: new Date("2024-01-08").toISOString(),
    BedroomsTotal: 2,
    BathroomsTotalInteger: 2,
    LivingAreaRange: 1400,
    BuildingAreaTotal: 1400,
    PublicRemarks: "Luxury penthouse with floor-to-ceiling windows, premium finishes, and exclusive amenities. Perfect for urban professionals.",
    PublicRemarksExtras: "Features private terrace, wine cellar, and premium appliances. Building includes concierge, valet parking, and rooftop pool.",
    PropertyType: "Residential",
    PropertySubType: "Condo Apartment",
    HeatSource: "Gas",
    HeatType: "Radiant Floor",
    GarageType: "Underground",
    ParkingTotal: 2,
    DirectionFaces: "West",
    LotSizeRangeAcres: "0.08",
    LotSizeUnits: "Acres",
    Basement: ["None"],
    ListOfficeName: "Premium Realty Group",
    ListAOR: "Toronto Real Estate Board",
    StandardStatus: "Active",
    ListAgentKey: "12345",
  },
  {
    ListingKey: "DEMO004",
    CrossStreet: "Danforth Avenue & Pape Avenue",
    CityRegion: "Riverdale",
    StreetNumber: "425",
    StreetName: "Danforth",
    StreetSuffix: "Ave",
    City: "Toronto",
    StateOrProvince: "ON",
    PostalCode: "M4K 1P3",
    ListPrice: 750000,
    OriginalEntryTimestamp: new Date("2024-01-05").toISOString(),
    BedroomsTotal: 2,
    BathroomsTotalInteger: 1,
    LivingAreaRange: 950,
    BuildingAreaTotal: 950,
    PublicRemarks: "Cozy family home in desirable Riverdale neighbourhood. Close to schools, parks, and shopping. Great investment opportunity.",
    PublicRemarksExtras: "Features updated kitchen, hardwood floors throughout, and private backyard. Perfect starter home or investment property.",
    PropertyType: "Residential",
    PropertySubType: "Semi-Detached",
    HeatSource: "Gas",
    HeatType: "Forced Air",
    GarageType: "None",
    ParkingTotal: 0,
    DirectionFaces: "North",
    LotSizeRangeAcres: "0.12",
    LotSizeUnits: "Acres",
    Basement: ["Unfinished"],
    ListOfficeName: "Premium Realty Group",
    ListAOR: "Toronto Real Estate Board",
    StandardStatus: "Active",
    ListAgentKey: "12345",
  },
  {
    ListingKey: "DEMO005",
    CrossStreet: "Queen Street West & Bathurst Street",
    CityRegion: "Trinity-Bellwoods",
    StreetNumber: "312",
    StreetName: "Queen",
    StreetSuffix: "St W",
    City: "Toronto",
    StateOrProvince: "ON",
    PostalCode: "M5V 2A2",
    ListPrice: 950000,
    OriginalEntryTimestamp: new Date("2024-01-03").toISOString(),
    BedroomsTotal: 1,
    BathroomsTotalInteger: 1,
    LivingAreaRange: 650,
    BuildingAreaTotal: 650,
    PublicRemarks: "Modern loft-style condo in trendy Queen West. Features exposed brick, high ceilings, and prime location near restaurants and cafes.",
    PublicRemarksExtras: "Converted warehouse space with original character. Includes storage locker and bike storage. Pet-friendly building.",
    PropertyType: "Residential",
    PropertySubType: "Condo Loft",
    HeatSource: "Electric",
    HeatType: "Radiant",
    GarageType: "None",
    ParkingTotal: 0,
    DirectionFaces: "South",
    LotSizeRangeAcres: "0.02",
    LotSizeUnits: "Acres",
    Basement: ["None"],
    ListOfficeName: "Premium Realty Group",
    ListAOR: "Toronto Real Estate Board",
    StandardStatus: "Active",
    ListAgentKey: "12345",
  },
  {
    ListingKey: "DEMO006",
    CrossStreet: "St. Clair Avenue West & Bathurst Street",
    CityRegion: "Corso Italia",
    StreetNumber: "678",
    StreetName: "St. Clair",
    StreetSuffix: "Ave W",
    City: "Toronto",
    StateOrProvince: "ON",
    PostalCode: "M6C 1B2",
    ListPrice: 680000,
    OriginalEntryTimestamp: new Date("2023-12-28").toISOString(),
    BedroomsTotal: 3,
    BathroomsTotalInteger: 2,
    LivingAreaRange: 1600,
    BuildingAreaTotal: 1600,
    PublicRemarks: "Spacious family townhouse with private backyard, two-car parking, and modern upgrades throughout. Ideal for families.",
    PublicRemarksExtras: "Features finished basement, double garage, and large deck. Close to schools, parks, and transit.",
    PropertyType: "Residential",
    PropertySubType: "Townhouse",
    HeatSource: "Gas",
    HeatType: "Forced Air",
    GarageType: "Attached",
    ParkingTotal: 2,
    DirectionFaces: "West",
    LotSizeRangeAcres: "0.15",
    LotSizeUnits: "Acres",
    Basement: ["Finished"],
    ListOfficeName: "Premium Realty Group",
    ListAOR: "Toronto Real Estate Board",
    StandardStatus: "Active",
    ListAgentKey: "12345",
  },
];

export default DEMO_LISTINGS;